import React from "react";
import {ReactHighstock} from "../../../../../lib/react-highcharts";
import moment from "moment/moment";
import {fillColor} from "../tools";
import { getStreamSessions } from "../../../../../../common/src/stream";

ReactHighstock.Highcharts.setOptions({
    global: {
        useUTC: false
    }
});

const absoluteTimeByPlayerTime = (time, stream) => {
    const sessions = getStreamSessions(stream);
    for (let i = 0; i < sessions.length; i++) {
        let session = sessions[i];

        if (session.timeStop) {
            let sessionDuration = session.timeStop - session.timeStart;
            if (sessionDuration >= time) {
                return session.timeStart + time;
            }
            time -= sessionDuration;
        } else {
            return session.timeStart + time;
        }
    }
    return null;
}

export const convertLiveWatches = (stream, intervals, rangeStart, rangeDuration) => {
    const watchPointSize = 60;
    const items = [];
    const itemByKey = {};
    const sessions = getStreamSessions(stream);
    const rangeStop = rangeStart + rangeDuration;
    const createKey = (time) => Math.round(time / watchPointSize) * watchPointSize;
    const rangeStartKey = createKey(absoluteTimeByPlayerTime(rangeStart, stream));
    const rangeStopKey = createKey(absoluteTimeByPlayerTime(rangeStart + rangeDuration, stream));
    const touchItemByKey = (key) => {
        let item = itemByKey[key];
        if (!item) {
            item = {
                time: key,
                start: 0,
                stop: 0,
                online: 0,
            };
            items.push(itemByKey[key] = item);
        }
        return item;
    };

    sessions.forEach(({timeStart, timeStop}) => {
        if (!timeStop) {
            timeStop = Math.round(Date.now() / 1000);
        }
        for (let time = timeStart; time <= timeStop; time += watchPointSize) {
            let key = createKey(time);
            if (key < rangeStartKey || key > rangeStopKey) {
                continue;
            }
            touchItemByKey(key);
        }
    });

    intervals.forEach(([timeStart, timeStop]) => {
        if (timeStart < rangeStart) {
            touchItemByKey(rangeStartKey).online++;
        } else if (timeStart < rangeStop) {
            let absoluteTimeStart = absoluteTimeByPlayerTime(timeStart, stream);
            if (null !== absoluteTimeStart/* && itemByKey[createKey(absoluteTimeStart)]*/) {
                touchItemByKey(createKey(absoluteTimeStart)).start++;
            }
        }

        if (timeStop && timeStop < rangeStop) {
            let absoluteTimeStop = absoluteTimeByPlayerTime(timeStop, stream);
            if (null !== absoluteTimeStop /* && itemByKey[createKey(absoluteTimeStop)] */) {
                touchItemByKey(createKey(absoluteTimeStop)).stop++;
            }
        }
    });

    let lastOnline = 0;
    return items
        .sort((a, b) => a.time - b.time)
        .map((item) => {
            lastOnline = item.online += lastOnline + item.start - item.stop;
            return item;
        })
        ;
}

export default ({watches, episodes}) => {
    const episodeColor = 'rgba(0, 0, 0, .1)';
    const episodeColorHover = 'rgba(0, 0, 0, .2)';
    const episodeColorBackground = 'rgba(255, 127, 127, .5)';

    const chartConfig = {
        accessibility: {
            enabled: false,
        },
        chart: {
            zoomType: 'x'
        },
        colors: ['#7cb5ec', '#90ed7d', '#f15c80'],
        title: {
            // text: `Зал "${stream.description_ru}"`,
            text: '',
        },
        rangeSelector: {
            inputEnabled: false,
            buttons: [
                {type: 'all', text: 'Весь'}
            ],
            selected: 1
        },
        credits: {
            enabled: false,
        },
        xAxis: {
            tickInterval: 60,
            labels: {
                formatter: ({value}) => moment(value).format('HH:mm'),
            },
            plotBands: episodes
                .map(({timeStart, timeStop}) => ({
                    from: timeStart * 1000,
                    to: timeStop * 1000,
                    color: episodeColor,
                    events: {
                        mouseover: function() {
                            this.svgElem.attr('fill', episodeColorHover);
                        },
                        mouseout: function() {
                            this.svgElem.attr('fill', episodeColor);
                        }
                    },
                    borderWidth: 1,
                    borderColor: episodeColorBackground,
                })),
        },
        plotOptions: {
            accessibility: {
                enabled: false,
            },
        },
        tooltip: {
            formatter: function() {
                let text = `<div><b>` + moment(this.x).format('LLL') + "</b></div>";
                text += this.points
                    .map((point) => `<div><b style="color: ${point.color}">○</b> ${point.series.name}: ${Math.round(point.y)}</div>`)
                    .join('');
                text += episodes
                    .filter(({timeStart, timeStop}) => timeStart * 1000 < this.x && timeStop * 1000 > this.x)
                    .map(({name}) => `<div class="highcharts-tooltip-episode"><b>Эпизод:</b> ${name}</div>`)
                    .join('');

                return text;
            },
            useHTML: true,
        },
        series: [{
            type: 'area',
            name: 'Просмотры',
            // step: true,
            data: watches.map(({time, online}) => ([time * 1000, online])),
            marker: {
                enabled: false,
            },
            fillColor: fillColor('#7cb5eca0', '#7cb5ec00')
        }, {
            type: 'column',
            name: 'Начало просмотра',
            data: watches.map(({time, start}) => ([time * 1000, start])),
            fillColor: fillColor('#90ed7da0', '#90ed7d00')
        }, {
            type: 'column',
            name: 'Конец просмотра',
            data: watches.map(({time, stop}) => ([time * 1000, stop])),
            fillColor: fillColor('#f15c80a0', '#f15c8000')
        }]
    };

    return (
        <ReactHighstock config={chartConfig} />
    );
};

